import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../../environments/environment';
import { BodyListResponse } from '../../../../core/models/general/body-list-response';

import { BodyResponse } from '../../../../core/models/general/body-response';
import { InfoResultadoCabDTO } from 'src/app/core/models/evaluacion/infoResultadoCab-DTO';
import { EvaluacionResultadoCoevaluacionCabDTO } from 'src/app/core/models/evaluacion/evaluacionResultadoCoevaluacionCab-DTO';

const API_URL = environment.apiUrlEvaluacion;

@Injectable()
export class ResultadoCoevaluacionCabService {
    header = new Headers({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) { }

    getEvaluacionResultadoCoevaluacionCabService() {
        return this.http.get<BodyListResponse<EvaluacionResultadoCoevaluacionCabDTO>>(
            API_URL + '/api/v1/resultadoCoevaluacionCab/todos'
        );
    }

    guardarEvaluacionResultadoCoevaluacionCabService(evaluacionResultadoCoevaluacionCabDTO: EvaluacionResultadoCoevaluacionCabDTO) {
        return this.http.post(API_URL + '/api/v1/resultadoCoevaluacionCab', evaluacionResultadoCoevaluacionCabDTO);
    }

    getEvaluacionResultadoCoevaluacionCabPorCodigoResultadoCoevaluacionCabService(codigoResultadoCoevaluacionCab: String) {
        return this.http.get<BodyResponse<EvaluacionResultadoCoevaluacionCabDTO>>(
            API_URL + '/api/v1/resultadoCoevaluacionCab/' + codigoResultadoCoevaluacionCab
        );
    }

    getResultadoCabPorCodigoResultadoCabPorDocumentoPorPeriodoService(perfil: String, documento: String, periodo: String) {
        return this.http.get<BodyResponse<InfoResultadoCabDTO>>(
            API_URL + '/api/v1/resultadoCoevaluacionCab/perfil/' + perfil + '/documento/' + documento + '/periodo/' + periodo
        );
    }


}
